import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import UpdateResumeModal from '@/views/apps/candidate/components/UpdateResumeModal.vue'
import {
  RESUME_ACCEPT,
  validateResumeFile,
  uploadCandidateResumeOnly,
  extractCandidateUpdateError,
  extractCvPath,
  isInActionCandidate,
} from '@/utils/upload-candidate-resume'

export default {
  components: {
    UpdateResumeModal,
  },
  data() {
    return {
      resumeAccept: RESUME_ACCEPT,
      resumeUploadCandidate: null,
      resumeUploading: false,
      resumeModalVisible: false,
    }
  },
  methods: {
    isInActionCandidate,
    startResumeUpload(candidate) {
      if (this.resumeUploading) return
      if (isInActionCandidate(candidate)) {
        this.openUpdateResume(candidate)
        return
      }
      this.resumeUploadCandidate = candidate
      this.$nextTick(() => {
        const input = this.$refs.resumeFileInput
        if (!input) return
        input.value = ''
        input.click()
      })
    },
    openUpdateResume(candidate) {
      if (this.resumeUploading) return
      this.resumeUploadCandidate = candidate
      this.resumeModalVisible = true
    },
    async onResumeFileSelected(event) {
      const input = event && event.target
      const file = input && input.files && input.files[0]
      const candidate = this.resumeUploadCandidate
      if (input) input.value = ''
      if (!file || !candidate) return
      await this.uploadResumeFile(candidate, file)
    },
    async submitResumeUpdate(file) {
      const candidate = this.resumeUploadCandidate
      if (!file || !candidate) return
      await this.uploadResumeFile(candidate, file, { closeModal: true })
    },
    async uploadResumeFile(candidate, file, options = {}) {
      const invalid = validateResumeFile(file)
      if (invalid) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: invalid,
            icon: 'AlertCircleIcon',
            variant: 'danger',
            timeout: 5000,
          },
        })
        return
      }

      this.resumeUploading = true
      try {
        const res = await uploadCandidateResumeOnly(candidate.id, file, candidate)
        if (res && res.status === 'OK') {
          this.applyUploadedResume(candidate, res)
          if (options.closeModal) this.resumeModalVisible = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: options.closeModal ? 'Resume updated successfully' : 'Resume uploaded successfully',
              icon: 'CheckIcon',
              variant: 'success',
              timeout: 5000,
            },
          })
        } else if (res && (res.status === 401 || res.status === 403)) {
          window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
          localStorage.clear()
          this.$router.push({ name: 'auth-login' })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: extractCandidateUpdateError(res),
              icon: 'AlertCircleIcon',
              variant: 'danger',
              timeout: 5000,
            },
          })
        }
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: extractCandidateUpdateError(err && err.response ? err.response : err),
            icon: 'AlertCircleIcon',
            variant: 'danger',
            timeout: 5000,
          },
        })
      } finally {
        this.resumeUploading = false
        if (!this.resumeModalVisible) this.resumeUploadCandidate = null
      }
    },
    applyUploadedResume(candidate, res) {
      const cvPath = extractCvPath(res)
      const id = candidate && candidate.id
      if (!id) return
      const lists = [this.fetchCandidates, this.fetchCandidatesBKP].filter(list => Array.isArray(list))
      lists.forEach(list => {
        const row = list.find(item => item && item.id === id)
        if (row && cvPath) this.$set(row, 'cv_path', cvPath)
      })
      if (cvPath) this.$set(candidate, 'cv_path', cvPath)
    },
  },
}
